/**
 * Servicio de datos para Préstamos Parametrizados (pre-aprobados de la app).
 *
 * Los endpoints /prestamos-parametrizados/* son proxies en IntraNode que
 * usan centrocardAuthService para autenticarse contra la API de Centrocard
 * (igual que adelantosService).
 *
 * Grupos de afinidad: services/gruposAfinidadService.js (servicio único).
 */

import ApiService from "../apiService";

const BASE = "/prestamos-parametrizados";

const PrestamosParametrizadosService = {
  getAll: () => ApiService.get(BASE),
  getById: (id) => ApiService.get(`${BASE}/${id}`),
  getPlanes: () => ApiService.get(`${BASE}/planes`),
  /** tipo: "DOCUMENTO" | "ID_CLIENTE"; valores: string[] → { encontrados, noEncontrados } */
  validarClientes: (tipo, valores) =>
    ApiService.post(`${BASE}/clientes/validar`, { tipo, valores }),
  create: (payload) => ApiService.post(BASE, payload),
  update: (id, payload) => ApiService.put(`${BASE}/${id}`, payload),
  toggle: (id) => ApiService.request("patch", `${BASE}/${id}/toggle`),
  remove: (id) => ApiService.delete(`${BASE}/${id}`),
};

export default PrestamosParametrizadosService;
